<template lang="pug">
div(class="card", :style="{ backgroundImage: 'url(' + imgUrl + ')' }")
  div(class="card-header") {{title}}
  div(class="card-body", :class="{'numeric-value': numericValue}") {{value}}
    div(class="subValue") {{subValue}}
</template>

<script>

export default {
  props: {
    title: String,
    value: String,
    subValue: [String, Number],
    img: String,
    numericValue: Boolean
  },
  data () {
    return {
      imgUrl: ''
    }
  },
  created () {
    switch (this.img) {
      case 'NUM_PROCESSOS':
        this.imgUrl = require('@/assets/images/cardNumProcessos.png'); // eslint-disable-line
        break
      case 'MAIS_SOLICITADO':
        this.imgUrl = require('@/assets/images/cardMaisSolicitado.png'); // eslint-disable-line
        break
      case 'MUNICIPIO':
        this.imgUrl = require('@/assets/images/cardMunicipio.png'); // eslint-disable-line
        break
      default:
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  width: 20%;
  overflow: hidden;
  color: white;
  background-color: #009f60;
  height: 180px;
  background-size: 35%;
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 40%;
  border-radius: 15px;
  margin: 2%;
  box-shadow: none;
  -webkit-box-shadow: none;
  .card-header{
    padding: 23px;
    box-sizing: border-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 1em;
    padding-bottom: 0;
    width: 70%;
    background-color: transparent;
  }

  .card-body {
    padding: 23px;
    font-size: 20px;
    font-weight: 600;
  }
  .subValue {
    font-weight: 100;
    font-size: 18px;
    padding-top: 10px;
  }
  .img {
    height: 150px;
    position: absolute;
    padding-left: 0px;
    margin-top: 55px;
    margin-left: 8.2%;
  }
  .numeric-value {
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppCard.vue